import { useTranslation } from "react-i18next";
import { appTheme, fetchConfigarationData, retrieveData } from "../../../../helpers/utils/Utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from "../../../../network/NetworkUtils";
import { GET_NOTIFICATION_SETTINGS, NOTIF_CONFIG_BANCORP, NOTIF_CONFIG_POLICY, NOTIF_CONFIG_SMS_SERVICE, PROGRAM_CONTENT, STATUS_SUCCESS_CODE, UPDATE_NOTIFICATION_SETTINGS } from "../../../../network/URLConstants";
import Loader from "../../../CustomComponents/Loader";
import { withOidcSecure } from "@axa-fr/react-oidc";
import NotificationConfigureTable from "../NotificationConfigureTable";
import NotificationFilter from "../NotificationFilter";
import arrow from "../../../../assets/images/arrow.png"
import { convertTo24HourFormat, displayErrorMessage } from "../../../../utils";
import HomeLayout from "../../../Layout/HomeLayout";
import HomeHeader from "../../../CustomComponents/HomeHeader";
import Modal from "../../../CustomComponents/Modal";
import DynamicCard from "../../../CustomComponents/DynamicComponent/DynamicCard.js";
import { useNavigate } from "react-router";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import LineBreaks from "../../../../utils";
import moment from "moment";
import logFirebaseEvents from "../../../LogFirebaseEvents";
import CardHeading from "../../../CustomComponents/CardHeading";
import LeftBar from "../../../CustomComponents/DynamicComponent/LeftBar";
import NotificationAccordion from "../../NotificationAccordion";
import UpdateNotificationErrorModal from "../UpdateNotificationErrorModal/index.js"; 
import redAlert from '../../../../assets/images/red_alert.png';
import UpdatedNotificationSuccessModal from "../UpdatedNotificationSuccessModal/index.js";
const appConfigData = await fetchConfigarationData();

const SMINotificationConfigure = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const [isLoading, setIsLoading] = useState(false);
    const [notificationSettings, setNotificationSettings] = useState(null);
    const [notificationConfig, setNotificationConfig] = useState(null);
    const [updatedNotificationConfig, setUpdatedNotificationConfig] = useState([]);
    const [notificationTimeFrame, setNotificationTimeFrame] = useState(null);
    const [isShowNotificationConfigContent, setIsShowNotificationConfigContent] = useState(false)
    const [isReset, setIsReset] = useState(false);
    const [optInForTextCom, setOptInForTextCom] = useState(true);
    const [policyURL, setPolicyURL] = useState('');
    const [showAgreementsModel, setShowAgreementsModel] = useState(false);
    const [isMobile, setIsMobile] = useState(true)
    const [infoMessage, setinfoMessage] = useState('');
    const isSMIOneAccount = useSelector(state => state.smiOneAccountTrue);
    const [isKudzuSelected, setIsKudzuSelected] = useState(false);
    const hasKudzuCard = useSelector((state) => state.hasKudzuCard);

    const accessToken = useSelector(state => state.accessToken);
    const userProfile = useSelector(state => JSON.parse(state.userProfile));
    const cards = useSelector(state => JSON.parse(state.userCards));

    const HeadingStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
    const SubHeadingStyles =
        "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";
    const [showErrorMsg, setShowErrorMessage] = useState("")
    const [errorModal, setErrorMadal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);

    const handleCloseErrorModal = () => {
        setErrorMadal(false)
        navigate("/Settings");
    }

    const handleCloseSuccessModal = () => {
        setSuccessModal(false)
    }

    const largeScreenMediaQuery = window.matchMedia('(min-width: 768px)');
    useEffect(() => {
        setIsMobile(largeScreenMediaQuery.matches); // Execute immediately if the screen size is already at or above 'sm'

    }, [])


    const getAgreementsBasedOnType = async (url) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);

        setIsLoading(true)

        let finalUrl = (PROGRAM_CONTENT + "?accountType=64&language=en&contentType=" + url + "&programKey=200")
        var response = await GetRequest(finalUrl, headers)
        var responseObj = JSON.parse(response)
        setIsLoading(false)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setPolicyURL(responseObj.Response.Data)
        } else {
            setTimeout(() => {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                // setError(displayText)
            }, 500);
        }
    }

    const LinkClick = (href, e) => {
        e.preventDefault();
        e.stopPropagation();
        switch (href) {
            case NOTIF_CONFIG_POLICY:
                logFirebaseEvents("Configure_Notification", "Kudzu_Privacy_Policy_Clicked", "Kudzu_Privacy_Policy_Clicked", "", "")
                getAgreementsBasedOnType("PPrivacyPolicy")
                setShowAgreementsModel(true);

                break;
            case NOTIF_CONFIG_SMS_SERVICE:
                logFirebaseEvents("Configure_Notification", "Kudzu_Alert_Terms_Of_Services_Clicked", "Kudzu_Alert_Terms_Of_Services_Clicked", "", "")
                getAgreementsBasedOnType("SMSTerms")
                setShowAgreementsModel(true);
                break;
            case NOTIF_CONFIG_BANCORP:
                logFirebaseEvents("Configure_Notification", "BanCorp_Privacy_Notice_Clicked", "BanCorp_Privacy_Notice_Clicked", "", "")
                getAgreementsBasedOnType("PrivacyPolicyV2")
                setShowAgreementsModel(true);

            default:
                break;
        }
    };


    const updateConfigObjectByAlertCode = (AlertCode, updatedKeyValues) => {
        const updatedNotificationConfigArray = notificationConfig.map((configObj) => {
            if (configObj.AlertCode === AlertCode) {
                return { ...configObj, ...updatedKeyValues };
            } else {
            }
            return configObj;
        });

        setNotificationConfig(updatedNotificationConfigArray);
    }

    const updateTimeFrame = (timeFrom, timeTo) => {
        setNotificationTimeFrame({
            "timeFrom": timeFrom,
            "timeTo": timeTo
        })
    }

    const fetchNotificationSettings = async (isKudzu) => {
        if (cards == null || cards == undefined) {
            return
        }
        try {
            setIsLoading(true);

            const deviceId = await retrieveData('updatedDeviceId')
            const cardKey = cards !== null ? cards.find((card) =>
                isKudzu
                  ? card.AccountTypeBit63 === 64
                  : card.AccountTypeBit63 === 1
            ).CardKey : 0;

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = GET_NOTIFICATION_SETTINGS(cardKey)
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                setNotificationSettings(responseJson.Response);
                const updateNotificationConfigObjWithCodeParameter = responseJson.Response.Notifications.map((obj) => {
                    return { ...obj, "Code": obj.AlertCode };
                })
                setNotificationConfig(updateNotificationConfigObjWithCodeParameter)
                setNotificationTimeFrame(
                    {
                        "timeFrom": responseJson.Response.NotificationFromTime,
                        "timeTo": responseJson.Response.NotificationToTime
                    }
                )
                setIsShowNotificationConfigContent(true);
            }

        } catch (error) {
        }
    }

    useEffect(() => {
        fetchNotificationSettings(false);
    }, [])

    const applyFilters = async () => {
        try {
            setIsLoading(true);

            const deviceId = await retrieveData('updatedDeviceId')
            const cardKey = cards !== null ? cards.find((card) =>
                isKudzuSelected
                  ? card.AccountTypeBit63 === 64
                  : card.AccountTypeBit63 === 1
            ).CardKey : 0;

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = UPDATE_NOTIFICATION_SETTINGS(cardKey)
            const body = {
                CardholderAlertNotifications: notificationConfig,  //to change the configurations selected by user
                NotificationFromTime: moment(notificationTimeFrame?.timeFrom, ['h:mm A', 'HH:mm:ss']).format('HH:mm'), // to change it to time selected by user
                NotificationToTime: moment(notificationTimeFrame?.timeTo, ['h:mm A', 'HH:mm:ss']).format('HH:mm')// to change it to time selected by user
            }
            const response = await PostRequest(url, body, headers);
            const responseJson = await JSON.parse(response);
            setinfoMessage('')
            setIsLoading(false);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setSuccessModal(true);
                fetchNotificationSettings(isKudzuSelected);
            }else{
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setShowErrorMessage(displayText)
                setIsLoading(false)
                setErrorMadal(true)
                 
            }

        } catch (error) {
            setIsLoading(false);
            setinfoMessage(error.message)
        }
    }

    useKeyDown(() => {

        applyFilters()

    }, ["Enter"]);

    const resetFilters = () => {
        logFirebaseEvents("Configure_Notification", "Reset_Clicked", "Reset_Clicked", "", "")
        const updateNotificationConfigObjWithCodeParameter = notificationSettings.Notifications.map((obj) => {
            return { ...obj, "Code": obj.AlertCode };
        })
        setNotificationConfig(updateNotificationConfigObjWithCodeParameter);
        setUpdatedNotificationConfig([]);
        setNotificationTimeFrame(
            {
                "timeFrom": notificationSettings.NotificationFromTime,
                "timeTo": notificationSettings.NotificationToTime

            })
        setIsReset(prev => !prev);
    }

    const checkMandatoryNotificationsDeselected = () => {
        if (!notificationConfig) return false;
       
        return notificationConfig.some(notification => {
            if (notification.Category === "Mandatory") {
                const hasEmail = notification.Email && notification.CanOptInToEmail;
                const hasSMS = notification.SMS && notification.CanOptInToSMS;
                const hasPush = notification.PushNotification && notification.CanOptInToPush;
               
                // Check if all available methods are deselected
                return !hasEmail && !hasSMS && !hasPush;
            }
            return false;
        });
    };

    const Headingcom = () => {
        return (
            <div className="relative">
                <div className={`flex flex-col justify-start my-12 sm:my-6 md:my-10 sm:mx-8 mx-12`}>
                     <p className={`font-hanken-grotesk font-[500] 
                       lg:text-[26px] md:text-[26px] 
                       sm:text-[15px] text-[16px] leading-[24px] sm:font-[600] 
                        sm:leading-[23px] md:font-[500] 
                         md:leading-[36px] ${kudzuPlusTrue ? "text-[#ffffff]" : ""} `}>{t("config_notification")}</p>
                </div>
            </div>
        )
    }

    const children = () => {
        return (
         <div className="flex justify-center sm:mx-0 mx-10">
                <div className="flex flex-col justify-center gap-10 sm:gap-8 md:gap-10 sm:py-16 w-full sm:w-[90%] md:w-[80%] ">
                    {isShowNotificationConfigContent &&
                        <div className=" w-full">
                            <p className="text-[var(--notificationText)] font-hanken-grotesk font-normal text-[12px] leading-[18px] sm:font-[500] sm:text-[10px] sm:leading-[16px] md:text-[14px] md:leading-[22px]"
  dangerouslySetInnerHTML={{
                                    __html: notificationSettings.Metadata.ShortCodeMessage.replaceAll(`style='color:#30BC89; text-decoration: none'`, `style='color:var(--notificationtextheadingsgreenColor); text-decoration: none; font-weight: 700'`)
                                        .replaceAll(`style='color:#2965FB; text-decoration: none'`, `style='color:var(--notificationtextheadingsColor); text-decoration: none; font-weight: 700'`)
                                        .replaceAll(`style='color:#30BC89;text-decoration: none text-decoration: none'`, `style='color:var(--notificationtextheadingsgreenColor);text-decoration: none; font-weight: 700'`)

                                }}                       
                                onClick={(e) => {
                                    if (e.target.tagName === 'A') {
                                        const href = e.target.getAttribute('href');
                                        LinkClick(href, e); // Pass the event object to useLinkClick
                                    }
                                }}
                            />
                        </div>
                    }

                    <hr className=" h-[2.5px] bg-blue-sky border-0 rounded" />
                    {isShowNotificationConfigContent && (
                        notificationSettings.Categories === null ? (
                            <NotificationConfigureTable
                                notifications={notificationSettings.Notifications}
                                updateConfigObjectByAlertCode={updateConfigObjectByAlertCode}
                                isReset={isReset}
                            />
                        ) : (
                            <NotificationAccordion
                                categories={notificationSettings.Categories}
                                notifications={notificationSettings.Notifications}
                                updateConfigObjectByAlertCode={updateConfigObjectByAlertCode}
                                isReset={isReset}
                            />
                        )
                    )}

                {isKudzuSelected && 
                 <>
                    {/* <hr className=" h-[2.5px] bg-blue-sky border-0 rounded" /> */}

                    <div className=" flex flex-row justify-between cursor-pointer" onClick={() => { navigate("/Toolkit/ToolkitSettings"); logFirebaseEvents("Configure_Notification", "Manage_Climb_Preference_Clicked", "Manage_Climb_Preference_Clicked", "", "") }}>
                        <p className="font-hanken-grotesk font-[500] text-[14px] leading-[20px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[18px]  text-[var(--isManageNotify)]"
                            tabIndex={0}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    navigate("/Toolkit/ToolkitSettings")
                                }
                            }}
                        >{t("manage_climb_preferences")}</p>
                        <img src={appThemeData.ArrowKudzuTo} alt="arrow" />
                    </div>

                </> 
                }
                    <hr className=" h-[2.5px] bg-blue-sky border-0 rounded" />

                    {/* Red Alert Message */}
                    {isShowNotificationConfigContent && checkMandatoryNotificationsDeselected() && isKudzuSelected &&(
                        <div className="bg-[#FCE1D7]  rounded-lg p-4 mt-4" style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
                            <div className="flex items-center gap-3">
                                <img src={redAlert} alt="Alert" className="w-10 h-10" />
                                <p className="font-hanken-grotesk font-[400] text-[16px] leading-[20px] text-black-700">
                                     {t("DESELECT_ERROR_MSG")}
                                </p>
                            </div>
                        </div>
                    )}
                    

                    {isShowNotificationConfigContent &&
                        <NotificationFilter
                            NotificationFromTime={notificationSettings.NotificationFromTime}
                            NotificationToTime={notificationSettings.NotificationToTime}
                            updateTimeFrame={updateTimeFrame}
                            TimeSelectionLable={notificationSettings.Metadata.TimeSelectionLable}
                            isReset={isReset}
                        />
                    }
                    {(infoMessage != '') &&
                        <div className='mb-2'>
                            {displayErrorMessage(infoMessage)}
                        </div>
                    }
                    {
                        kudzuPlusTrue ? ( 
                            <div class="flex flex-col-reverse sm:flex-row items-center sm:space-x-6 mt-4 mb-10 sm:mb-0 justify-end gap-4 sm:gap-0">
        
                                <button class={`font-hanken-grotesk font-[500] text-[16px] 
                                sm:font-[700] sm:text-[13px] md:font-[700] md:text-[14px] 
                                sm:text-[var(--notificationResetclr)] 
                                cursor-pointer w-auto 
                                 capitalize  ${kudzuPlusTrue ? 'border-2 border-[#4B70B9] text-white  px-2 sm:px-0 lg:px-14 py-[1rem]' : ' px-2 sm:px-0 lg:px-2 py-4 text-[#2965FB] sm:bg-inherit bg-[#D6E2E8]'} `}
                                    onClick={resetFilters}
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            // event.preventDefault();
                                            // resetFilters();
                                            debugger;
                                            const updateNotificationConfigObjWithCodeParameter = notificationSettings.Notifications.map((obj) => {
                                                return { ...obj, "Code": obj.AlertCode };
                                            })
                                            setNotificationConfig(updateNotificationConfigObjWithCodeParameter);
                                            setUpdatedNotificationConfig([]);
                                            setNotificationTimeFrame(
                                                {
                                                    "timeFrom": notificationSettings.NotificationFromTime,
                                                    "timeTo": notificationSettings.NotificationToTime
        
                                                })
                                            setIsReset(prev => !prev);
                                        }
                                    }}
                                >{t("RESET_ALL")}</button>
        
        
                                <button class={`font-hanken-grotesk font-[500] text-[16px]  sm:font-[700]
                                 sm:text-[13px] md:font-[700] md:text-[16px] 
                                  cursor-pointer w-auto
                                     capitalize
                                 text-[var(--notificationResetclr)] ${kudzuPlusTrue ? 'bg-[#2965FB]  px-2 sm:px-0 lg:px-14 py-[1rem] ' : 'sm:bg-inherit bg-[#2965FB] px-2 sm:px-0 lg:px-2 py-4'} `}
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            applyFilters();
                                        }
                                    }}
                                    onClick={() => { applyFilters(); logFirebaseEvents("Configure_Notification", "Save_Clicked", "Save_Clicked", "", "") }}
                                >{t("save")}</button>
                            </div>
                        ) : (
                            <div class="flex flex-col-reverse sm:flex-row items-center sm:space-x-6 mt-4 mb-10 sm:mb-0 justify-end gap-4 sm:gap-0">
        
                                <button class={`font-hanken-grotesk font-[500] text-[16px] 
                                sm:font-[700] sm:text-[13px] md:font-[700] md:text-[14px] 
                                text-[#2965FB]  w-auto
                                cursor-pointer  
                                 capitalize  bg-[#D6E2E8]  px-2 sm:px-0 lg:px-14 py-[1rem]  `}
                                    onClick={resetFilters}
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            // event.preventDefault();
                                            // resetFilters();
                                            debugger;
                                            const updateNotificationConfigObjWithCodeParameter = notificationSettings.Notifications.map((obj) => {
                                                return { ...obj, "Code": obj.AlertCode };
                                            })
                                            setNotificationConfig(updateNotificationConfigObjWithCodeParameter);
                                            setUpdatedNotificationConfig([]);
                                            setNotificationTimeFrame(
                                                {
                                                    "timeFrom": notificationSettings.NotificationFromTime,
                                                    "timeTo": notificationSettings.NotificationToTime
        
                                                })
                                            setIsReset(prev => !prev);
                                        }
                                    }}
                                >{t("RESET_ALL")}</button>
        
        
                                <button class={`font-hanken-grotesk font-[500] text-[16px]  sm:font-[700]
                                 sm:text-[13px] md:font-[700] md:text-[16px] cursor-pointer capitalize text-[#fff] bg-[#2965FB]  px-2 sm:px-0 lg:px-14 py-[1rem] w-auto`}
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            applyFilters();
                                        }
                                    }}
                                    onClick={() => { applyFilters(); logFirebaseEvents("Configure_Notification", "Save_Clicked", "Save_Clicked", "", "") }}
                                >{t("save")}</button>
                            </div>
                        )
                    }
                


                </div>

            </div>

        )
    }

    const leftBarComp = () => {
        return (
          <>
            <div className="lg:w-[260px] md:w-[183px] sm:w-[164px] w-full sm:mx-0 ml-[2.5rem]">
              <p
                className="text-white font-normal
                        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                        sm:leading-[30px] leading-[31px]
              font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px]  sm:border-opacity-[50%]
              sm:pb-[2.6rem] pb-[2.6rem] mb-10"
              >
               {LineBreaks(t("SMI_Configure_Setting_Side_Heading"))}
              </p>
    
                <div className="flex flex-col gap-4 text-white w-[80%]">
                  {/* smiONE Header */}
                  <div
                    className={`font-bold text-[16px] cursor-pointer ${!isKudzuSelected ? 'text-[#94C3E8]' : 'text-white'}`}
                    onClick={() => {
                        setIsKudzuSelected(false)
                        fetchNotificationSettings(false);
                    }}
                  >
                    smiONE
                  </div>
                  <div className="flex flex-col gap-4 text-white w-[80%]">
                    {/* Kudzu Header */}
                            {hasKudzuCard &&
                                <div
                                    className={`font-bold text-[16px] cursor-pointer ${isKudzuSelected ? 'text-[#94C3E8]' : 'text-white'}`}
                                    onClick={() => {
                                        setIsKudzuSelected(true);
                                        fetchNotificationSettings(true);
                                    }}
                                >
                                    {"Kudzu"}
                                </div>
                            }

                  </div>
                </div>
            </div>
          </>
        );
      };
    


    return (

        <>
           
            <HomeLayout>
                {isSMIOneAccount && <LeftBar leftBarType="component" leftBarComp={leftBarComp()} />}
                {isSMIOneAccount && <div className="md:w-[150px] sm:w-[70px] w-[0px]"></div>}
                {!isSMIOneAccount && <HomeHeader heading={LineBreaks(t("SMI_Configure_Setting_Side_Heading"))} isHeaderCaption={true} />}
                <div className='flex flex-col md:w-[860px] 
                sm:w-[464px] w-[100%] animate__animated animate__fadeInRight '>

                    <DynamicCard
                        headerContent={Headingcom()}
                        HeaderRadius={true}
                        footer={true}
                        cardContent={children()}
                        isCardFooter={kudzuPlusTrue}
                        cardHeight='content-fit'
                    >

                        {children()}
                    </DynamicCard>

                </div>
            </HomeLayout >
            {isLoading && <Loader />}

             <Modal
                            isOpen={errorModal}
                            onClose={(e) => {
                                setErrorMadal(false); 
                                navigate("/Settings");
                            }}
                            alignItems={"items-center"}
                            isClimbg={true}
                            title={
                                <p className={`${HeadingStyles} hidden sm:flex`}>
                                    {t("oops_exclamation")}
                                </p>
                            }
                            subtitle={
                                <p>
                                    <span className={`${HeadingStyles} visible sm:hidden`}>
                                        {t("oops_exclamation")}
                                    </span>
                                    <span className={SubHeadingStyles}>{showErrorMsg}</span>
                                </p>
                            }
                            content={
                                <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                                    <UpdateNotificationErrorModal ModalClose={handleCloseErrorModal} errormsg={showErrorMsg}/>
                                </div>
                            }
                        />

                        <Modal
                            isOpen={successModal}
                            onClose={(e) => {
                                setSuccessModal(false); 
                            }}
                            alignItems={"items-center"}
                            isClimbg={true}
                            title={
                                <p className={`${HeadingStyles} hidden sm:flex`}>
                                    {t("Success.")}
                                </p>
                            }
                            subtitle={
                                <p className="mb-36">
                                    <span className={`${HeadingStyles} visible sm:hidden`}>
                                        {t("Update_success_nts")}
                                    </span>
                                    <span className={SubHeadingStyles}>{t('Update_success_nts')}</span>
                                </p>
                            }
                            content={
                                <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                                    <UpdatedNotificationSuccessModal ModalClose={handleCloseSuccessModal}/>
                                </div>
                            }
                        />


            <Modal isIframe={true}
                isOpen={showAgreementsModel}
                onClose={() => setShowAgreementsModel(false)}
                title={false}
                content={<div className="h-[100%] w-full md:pt-0 sm:pt-6  pt-16" style={{ height: window.innerHeight }}>
                    <iframe style={{ height: window.innerHeight }} src={policyURL}
                        title="Embedded Website" className="w-full h-full rounded-br-[4rem]"
                    /></div>
                }
            />

        </>


    )
}

export default withOidcSecure(SMINotificationConfigure)